export default __webpack_public_path__ + "static/media/Suggestions Guidelines.579b5a1c.jpg";